import React, { useState } from "react";
import * as AlertDialog from "@radix-ui/react-alert-dialog";
import { Trash2, Edit3, Plus } from "lucide-react";
// import NewSubFactor from './NewSubFactor'

import { CATEGORY_VISIBILITY, CATEGORY_INPUT } from "data/AdminData"


import Options from "categories/Options"
import SubFactors from "categories/Options/SubFactors"

const ListJson = ({
    surveyStrucRow,
    setRowId,
    setOpenNewCategory,
    setSurveyStruc,
    setSurveyStrucRow,
    surveyStructureId,
    loading,
    setUpdateJsonFile,
}) => {
    // const [selectedItem, setSelectedItem] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false)
    const [showOptions, setShowOptions] = useState(false)
    const [optionItem, setOptionItem] = useState(false)
    const [showSubFactors, setShowSubFactors] = useState(false)
    const [subfactorList, setSubfactorList] = useState(false)
    const [deleteRow, setDeleteRow] = useState(false)


    function SelectRow(item) {
        setRowId(item?.id);
        setOpenNewCategory(true);
        setSurveyStruc(item);
    }

    function SelectSubFactorRow(item) {
        // console.log(item.id)
        setShowOptions(true)
        setRowId(item?.id);

        setOptionItem(item);
        // setOpenSubFactor(true);
        // setSelectedItem(item);
    }

    function SelectedDeleteRow(item){

        if (item) {
            setConfirmOpen(true)
            setDeleteRow(item)
        } else {
            setConfirmOpen(false)
            setDeleteRow(false)
        }
    }

    function RemoveFromList() {

        setConfirmOpen(false)
        // setLoading(true)
        const _ssRow = surveyStrucRow.filter(sc => sc.id !== deleteRow.id)

        setSurveyStrucRow(_ssRow)
        setUpdateJsonFile(Math.random())
        // const timer1 = setTimeout(() => {
        //     SaveSurveyStructure()
        // }, 500);
        // return () => clearTimeout(timer1);
    }

    if (showSubFactors) {
        return <SubFactors
            surveyStructureId={surveyStructureId}
            optionItem={optionItem}
            setSurveyStruc={setSurveyStruc}
            setShowOptions={setShowOptions}
            subfactorList={subfactorList}
            setShowSubFactors={setShowSubFactors}
            loading={loading}

            // save data
            surveyStrucRow={surveyStrucRow}
            setSurveyStrucRow={setSurveyStrucRow}
            setUpdateJsonFile={setUpdateJsonFile}

        />
    }
    if (showOptions) {
        return <Options
            surveyStructureId={surveyStructureId}
            optionItem={optionItem}
            setSurveyStruc={setSurveyStruc}
            loading={loading}
            // setLoading={setLoading}
            setShowOptions={setShowOptions}
            setSubfactorList={setSubfactorList}
            setShowSubFactors={setShowSubFactors}
            // save data
            surveyStrucRow={surveyStrucRow}
            setSurveyStrucRow={setSurveyStrucRow}
            setUpdateJsonFile={setUpdateJsonFile}
  
        />
    }

	console.log("surveyStrucRow", surveyStrucRow)
	return (
		<div className="relative rounded-lg border border-gray-200 bg-white p-4 shadow-sm md:p-6">
			{loading && (
				<div className="absolute inset-0 z-10 grid place-items-center bg-white/60 backdrop-blur-sm">
					<div className="h-6 w-6 animate-spin rounded-full border-2 border-blue-600 border-t-transparent" />
				</div>
			)}
			<div className="overflow-x-auto">
				<table className="min-w-full table-auto border-collapse">
					<thead>
						<tr className="border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
							<th className="px-3 py-2">Name</th>
							<th className="px-3 py-2">Priority</th>
							<th className="px-3 py-2">Subtitle</th>
							<th className="px-3 py-2">Visibility</th>
							<th className="px-3 py-2">Input</th>
							<th className="px-3 py-2">Access Order</th>
							<th className="px-3 py-2" />
							<th className="px-3 py-2" />
							<th className="px-3 py-2" />
						</tr>
					</thead>
					<tbody>
						{surveyStrucRow && Array.isArray(surveyStrucRow) ? (
							surveyStrucRow.map((item, i) => (
								<tr key={item?.id || i} className="border-b border-gray-100 hover:bg-gray-50">
									<td className="px-3 py-2 text-sm text-gray-800">{item?.name}</td>
									<td className="px-3 py-2 text-sm text-gray-800">{item?.priority}</td>
									<td className="px-3 py-2 text-sm text-gray-800">{item?.subtitle}</td>
									<td className="px-3 py-2 text-sm text-gray-700">
										{CATEGORY_VISIBILITY.find(({ value }) => value === item?.visibility)?.label}
										<br /> <small className="text-gray-500">{item?.visibility}</small>
									</td>
									<td className="px-3 py-2 text-sm text-gray-700">
										{CATEGORY_INPUT.find(({ value }) => value === item?.input)?.label}
										<br /> <small className="text-gray-500">{item?.input}</small>
									</td>
									<td className="px-3 py-2 text-sm text-gray-800">
										{Number.isFinite(Number(item?.access_order)) ? Number(item?.access_order) : "-"}
									</td>
									<td className="px-3 py-2">
										<button
											onClick={() => SelectSubFactorRow(item)}
											className="inline-flex h-9 items-center justify-center gap-2 rounded-md bg-blue-600 px-3 text-sm font-medium text-white hover:bg-blue-700"
										>
											<Plus className="h-4 w-4" />
											Options
										</button>
									</td>
									<td className="px-3 py-2">
										<button
											type="button"
											onClick={() => SelectedDeleteRow(item)}
											className="inline-flex items-center justify-center rounded-md border border-red-200 bg-white p-2 text-red-600 hover:bg-red-50"
											aria-label="Delete category"
										>
											<Trash2 className="h-4 w-4" />
										</button>
									</td>
									<td className="px-3 py-2">
										<button
											className="inline-flex h-9 items-center justify-center gap-2 rounded-md border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
											onClick={() => {
												SelectRow(item);
											}}
										>
											<Edit3 className="h-4 w-4" />
											Edit
										</button>
									</td>
								</tr>
							))) : (
							<tr>
								<td className="px-3 py-4 text-sm text-red-600" colSpan={9}>Error: surveyStrucRow is not a valid array.</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>

			<AlertDialog.Root open={confirmOpen} onOpenChange={setConfirmOpen}>
				<AlertDialog.Portal>
					<AlertDialog.Overlay className="fixed inset-0 z-40 bg-black/30" />
					<AlertDialog.Content className="fixed left-1/2 top-1/2 z-50 w-[95vw] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-lg border border-gray-200 bg-white p-6 shadow-lg">
						<AlertDialog.Title className="text-base font-semibold text-gray-900">
							Warning: Irreversible decision DELETING ⇒ {deleteRow?.name}
						</AlertDialog.Title>
						<AlertDialog.Description className="mt-2 text-sm text-gray-600">
							This will delete {deleteRow?.name} ⇒ {deleteRow?.priority} = {deleteRow?.subtitle} and its associated sub factors. This cannot be reversed. Are you sure?
						</AlertDialog.Description>
						<div className="mt-6 flex items-center justify-end gap-3">
							<AlertDialog.Cancel asChild>
								<button
									onClick={() => SelectedDeleteRow(false)}
									className="inline-flex h-9 items-center justify-center rounded-md border border-gray-300 bg-white px-4 text-sm font-medium text-gray-700 hover:bg-gray-50"
								>
									Cancel
								</button>
							</AlertDialog.Cancel>
							<AlertDialog.Action asChild>
								<button
									onClick={() => RemoveFromList()}
									className="inline-flex h-9 items-center justify-center rounded-md bg-red-600 px-4 text-sm font-medium text-white hover:bg-red-700"
								>
									Delete
								</button>
							</AlertDialog.Action>
						</div>
					</AlertDialog.Content>
				</AlertDialog.Portal>
			</AlertDialog.Root>
		</div>
	);
};

export default ListJson;